import { ChakraFlex as Flex } from "@airhelp/react-ui-components";
import RichtextAdapter from "modules/storyblok/adapters/RichtextAdapter";
import { isEmpty } from "modules/storyblok/adapters/RichtextAdapter/utils";
import { useRouter } from "next/router";
import type { AhPlusPricingPlansCards } from "../AhPlusPricingPlans.d";
import { contentStyles } from "./PlanBox.style";
import { updateContent } from "./PlanBox.utils";

export const PlanBox = ({
  content,
  planType,
}: {
  content: AhPlusPricingPlansCards["content"];
  planType: AhPlusPricingPlansCards["planType"];
}) => {
  const { query } = useRouter();
  const updatedContent = updateContent(planType, query, content);

  return (
    <Flex
      bg="white"
      alignSelf={{ base: "center", md: "unset" }}
      w="full"
      maxW="400px"
      rounded="xl"
      direction="column"
      sx={contentStyles}
    >
      {!isEmpty(updatedContent) && <RichtextAdapter content={updatedContent} />}
    </Flex>
  );
};
